import { render, staticRenderFns } from "./HubSocialButtons.vue?vue&type=template&id=ba1a568c"
import script from "./HubSocialButtons.vue?vue&type=script&lang=js"
export * from "./HubSocialButtons.vue?vue&type=script&lang=js"
import style0 from "./HubSocialButtons.vue?vue&type=style&index=0&id=ba1a568c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports